import React, { useState, useEffect } from 'react';
import SlideDown from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import DropDown from './DropDown';
import './selectsearch.scss';

const SelectSearch = ({
  label,
  id,
  selectData,
  placeholder,
  onSelect = () => {},
  name,
  selected,
  setSelected,
  cityId,
  setCityId,
  pointerEvent,
}) => {
  const [open, setOpen] = useState(false);
  const [filteredData, setFilteredData] = useState(selectData);
  const [isSelected, setIsSelected] = useState(false);

  const handleClick = (e) => {
    setOpen((prev) => !prev);

    if (selected) {
      setSelected('');
    }
  };
  const handleSelect = (el, name) => {
    setSelected(el);
    onSelect(el);
    setOpen(false);
  };

  useEffect(() => {
    setFilteredData(
      selectData.filter((data) => {
        return data.name.toUpperCase().includes(selected.toUpperCase());
      })
    );
  }, [selected, selectData, isSelected]);

  useEffect(() => {
    const handleClick = (e) => {
      if (!e.target.closest('#SelectDropdown-' + id)) {
        setOpen(false);
      }
    };

    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, [id]);

  return (
    <div
      className={`select_main ${pointerEvent ? 'disabled_select' : ''}`}
      id={'SelectDropdown-' + id}
      name={name}
    >
      <span className="select_text"> {label} </span>
      <div className="select_container_main" onClick={(e) => handleClick(e)}>
        <div className={`select_container ${open ? 'opened' : ''}`}>
          <input
            type="text"
            className=" value input-select"
            placeholder={placeholder}
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
          />
        </div>
        <button
          className={`dropdown_button ${open ? 'opened' : ''}`}
          type="text"
        >
          <div className={`${open ? 'button_active' : ''} button_dropdown`}>
            <DropDown />
          </div>
        </button>
      </div>
      <SlideDown>
        <div
          className={
            open ? 'select_option_container ' : 'select_option_container close'
          }
        >
          {filteredData?.map((el, i) => (
            <div
              className="select_option"
              key={i}
              onClick={() => handleSelect(el.name, setCityId(el.id))}
            >
              {el.name}
            </div>
          ))}
        </div>
      </SlideDown>
    </div>
  );
};

export default SelectSearch;
